<script lang="ts">
export default {
  name: 'Step1Binders',
};
</script>

<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { useDataReadinessWizard } from '@/composables/useDataReadinessWizard';
import DocumentStatusTable from '@/components/v2/data_readiness/DocumentStatusTable.vue';

const wizard = useDataReadinessWizard();

onBeforeMount(() => wizard.refreshDocuments('Binder'));
</script>

<template>
  <div class="p-6">
    <h2 class="mb-1 text-base font-semibold">Binder documents</h2>
    <p class="mb-4 text-sm text-base-content/60">
      Review all binders for this client. Upload a file where missing, then publish binders to make them visible on the client portal. At least one
      binder must be uploaded and published to proceed.
    </p>
    <DocumentStatusTable document-type="Binder" />
  </div>
</template>
